import React from 'react'

import ReportSegment from '../../generic/report-segment'

import Report from '../../../utility/report-service'

import {
  faBook,
  faComment,
  faProjectDiagram,
  faTag,
  faAlignLeft,
  faCheck,
  faExchangeAlt,
  faTimes,
  faHeading,
} from '@fortawesome/free-solid-svg-icons'

function DailyMonitoring() {
  return (
    <section className="daily-monitoring">
      <div className="container">
        <h2 id="crawling-result">Crawling Result</h2>
        <div className="row halves">
          <ReportSegment title="Responses" subtitle="" data={Report.crawledPages}>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
            accusam et justo duo dolores et ea rebum.
          </ReportSegment>
          <ReportSegment title="Index" subtitle="" data={Report.crawledPages.index}>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
            accusam et justo duo dolores et ea rebum.
          </ReportSegment>
          <ReportSegment title="Page Size" subtitle="" data={Report.crawledPages.pageSize}>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
            accusam et justo duo dolores et ea rebum.
          </ReportSegment>
          <ReportSegment title="Performance" subtitle="" data={Report.crawledPages.performance}>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
            accusam et justo duo dolores et ea rebum.
          </ReportSegment>
        </div>

        <h2 id="new-pages" className="secondary">
          New Pages
        </h2>
        <div className="row thirds">
          <ReportSegment
            title="Found ok"
            subtitle="Response code 200"
            data={Report.newPages.responses.foundOk}
            icon={faCheck}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment
            title="Redirect"
            subtitle="Response code 300"
            data={Report.newPages.responses.redirect}
            icon={faExchangeAlt}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment
            title="Error"
            subtitle="Response code 500"
            data={Report.newPages.responses.error}
            icon={faTimes}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment
            title="Titles"
            subtitle="Response code 500"
            data={Report.newPages.titles}
            icon={faTimes}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment
            title="Descriptions"
            subtitle="Response code 500"
            data={Report.newPages.descriptions}
            icon={faTimes}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment
            title="Canonicals"
            subtitle="Response code 500"
            data={Report.newPages.canonicals}
            icon={faTimes}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
        </div>

        <h2 id="lost-pages" className="secondary">
          Lost Pages
        </h2>
        <div className="row thirds">
          <ReportSegment
            title="Found ok"
            subtitle="Response code 200"
            data={Report.lostPages.responses.foundOk}
            icon={faCheck}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment
            title="Redirect"
            subtitle="Response code 300"
            data={Report.lostPages.responses.redirect}
            icon={faExchangeAlt}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment
            title="Error"
            subtitle="Response code 500"
            data={Report.lostPages.responses.error}
            icon={faTimes}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
        </div>

        <h2 id="changes" className="secondary">
          Changes
        </h2>
        <div className="row thirds">
          <ReportSegment title="Titles" subtitle="" data={Report.title} icon={faBook}>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment
            title="Descriptions"
            subtitle=""
            data={Report.description}
            icon={faComment}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment title="H1" subtitle="Bottom text" icon={faHeading} data={Report.h1}>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment
            title="Index"
            subtitle="Bottom text"
            icon={faProjectDiagram}
            data={Report.index}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment
            title="Canonical"
            subtitle="Bottom text"
            icon={faTag}
            data={Report.canonical}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment
            title="Wordcount"
            subtitle="Bottom text"
            icon={faAlignLeft}
            data={Report.wordCount}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
        </div>
      </div>
    </section>
  )
}

export default DailyMonitoring
